import React from 'react'
import get from 'lodash/get'
import { connect } from 'react-redux'
import { convertToMeters, convertToSeconds } from 'supporticon/utils/units'
import { formatCustomFitnessType } from '../../../../lib/fitness'
import { refetchFundraisingPage } from '../../../../store/fundraisingPage'
import { selectLocalisation } from '../../../../store/site'

import Activity from '../Activity'
import Button from '../../../ui/Button'
import ButtonGroup from 'constructicon/button-group'
import CreateFitnessForm from 'supporticon/components/create-fitness-form'
import EditFitnessForm from '../../EditPage/EditFitnessForm'
import Icon from 'constructicon/icon'
import Modal from '../../../ui/FlatModal'
import RichText from 'constructicon/rich-text'
import Section from 'constructicon/section'
import Success from '../../../ui/Success'
import Title from '../../../ui/Title'

class CreateFitness extends React.Component {
  constructor () {
    super()
    this.state = {
      data: {},
      modal: 'closed',
      success: false
    }
  }

  handleClose () {
    this.setState({ modal: 'closed', success: false })
  }

  render () {
    const { data, modal, success } = this.state
    const {
      customFitnessType,
      customFitnessTypePlural,
      customSupporterPage,
      fitnessTypes,
      isCustom,
      onSuccess,
      page,
      refetchFundraisingPage,
      uom,
      user
    } = this.props

    const label = isCustom ? `Log ${formatCustomFitnessType(customFitnessType, customFitnessTypePlural)}` : 'Log fitness'

    const fitnessOptions = get(customSupporterPage, 'fitness', {})
    const isStravaConnected = get(page, 'fitness.pageFitnessSettings.subscribedActivities', []).length > 0

    return (
      <div>
        <ButtonGroup>
          {fitnessOptions.strava && (
            <Button
              background='strava'
              onClick={() => this.setState({ modal: 'strava' })}
            >
              <Icon name='strava' />
              <span>
                {isStravaConnected ? 'Manage Strava' : 'Connect Strava'}
              </span>
            </Button>
          )}
          <Button onClick={() => this.setState({ modal: 'manual' })}>
            {label}
          </Button>
        </ButtonGroup>
        <Modal
          contentLabel={label}
          isOpen={modal === 'manual'}
          spacing={1.5}
          onRequestClose={() => this.handleClose()}
        >
          {success ? (
            <Success title='Logged successfully'>
              <Section spacing={{ b: 0.5 }}>
                <Activity
                  {...data}
                  activityType='fitness'
                  distance={convertToMeters(data.distance, data.unit)}
                  duration={convertToSeconds(data.duration, data.durationUnit)}
                  elevation={convertToMeters(data.elevation, data.elevationUnit)}
                  customFitnessType={customFitnessType}
                  isCustom={isCustom}
                />
              </Section>
              <Button onClick={() => this.handleClose()}>
                Close
              </Button>
            </Success>
          ) : (
            <div>
              <Title spacing={{ b: 1 }}>{label}</Title>
              <CreateFitnessForm
                distanceLabel={isCustom ? formatCustomFitnessType(customFitnessType, customFitnessTypePlural) : 'Distance'}
                type={fitnessTypes.length > 0 && fitnessTypes[0]}
                types={fitnessTypes.filter(type => type !== 'manual')}
                includeUnit={!isCustom}
                includeDuration={!isCustom}
                includeElevation={!isCustom}
                includeType={fitnessTypes.length > 1}
                inputField={{
                  styles: {
                    label: {
                      '&:first-letter': {
                        textTransform: 'capitalize'
                      }
                    }
                  }
                }}
                onSuccess={(_, data) => {
                  this.setState({ data, success: true }, () => setTimeout(onSuccess, 1000))
                  refetchFundraisingPage(page.slug)
                }}
                pageId={page.uuid}
                pageSlug={page.slug}
                uom={uom}
                userId={user.uuid}
                submit={label}
                token={user.token}
              />
            </div>
          )}
        </Modal>
        <Modal
          contentLabel='Manage Strava Settings'
          isOpen={modal === 'strava'}
          spacing={1.5}
          onRequestClose={() => this.handleClose()}
        >
          <Title spacing={{ b: 1 }}>
            {isStravaConnected ? 'Manage Strava Settings' : 'Connect to Strava'}
          </Title>
          <RichText>
            <p>
              {isStravaConnected
                ? 'Your page is automatically updated with fitness activities from your Strava account.'
                : 'Connect your Strava account to automatically update your page with your fitness activities.'
              }
            </p>
            <Section
              foreground='strava'
              size={-1}
              spacing={0}
              margin={{ t: -0.5 }}
              tag='p'
            >
              <a
                href='https://help.justgiving.com/hc/en-us/articles/360019657217-Use-of-Your-Strava-Data'
                target='_blank'
              >
                Learn more about the use of your data
              </a>
            </Section>
          </RichText>
          <Section spacing={0} margin={{ t: 1 }}>
            <EditFitnessForm
              fitnessOptions={fitnessOptions}
              fundraisingPage={page}
              user={user}
            />
          </Section>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  ...selectLocalisation(state)
})

const mapDispatchToProps = { refetchFundraisingPage }

export default connect(mapStateToProps, mapDispatchToProps)(CreateFitness)
